import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "LOT_NDVI_INDEX": {
        meta: {
            i18nDescrKey: "lot_ndvi_index",
            filters: ['s-c-leader-select-nav-bar-item', 'farm-select-nav-bar-item', 'campaign-select-nav-bar-item', "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "SATELLITE_INDEXES"
        },
        component: () => import("./components/tiles/GenericSateliteWidgetTile.vue")
    },
    "LOT_NDWI_INDEX": {
        meta: {
            i18nDescrKey: "lot_ndwi_index",
            filters: ['s-c-leader-select-nav-bar-item', 'farm-select-nav-bar-item', 'campaign-select-nav-bar-item', "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "SATELLITE_INDEXES"
        },
        component: () => import("./components/tiles/GenericSateliteWidgetTile.vue")
    },
    "LOT_CIRE_INDEX": {
        meta: {
            i18nDescrKey: "lot_cire_index",
            filters: ['s-c-leader-select-nav-bar-item', 'farm-select-nav-bar-item', 'campaign-select-nav-bar-item', "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "SATELLITE_INDEXES"
        },
        component: () => import("./components/tiles/GenericSateliteWidgetTile.vue")
    },
    "LOT_NDRE1_INDEX": {
        meta: {
            i18nDescrKey: "lot_ndre1_index",
            filters: ['s-c-leader-select-nav-bar-item', 'farm-select-nav-bar-item', 'campaign-select-nav-bar-item', "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "SATELLITE_INDEXES"
        },
        component: () => import("./components/tiles/GenericSateliteWidgetTile.vue")
    },
    "LOT_NDRE2_INDEX": {
        meta: {
            i18nDescrKey: "lot_ndre2_index",
            filters: ['s-c-leader-select-nav-bar-item', 'farm-select-nav-bar-item', 'campaign-select-nav-bar-item', "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "SATELLITE_INDEXES"
        },
        component: () => import("./components/tiles/GenericSateliteWidgetTile.vue")
    },
    "LOT_EVI2_INDEX": {
        meta: {
            i18nDescrKey: "lot_evi2_index",
            filters: ['s-c-leader-select-nav-bar-item', 'farm-select-nav-bar-item', 'campaign-select-nav-bar-item', "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "SATELLITE_INDEXES"
        },
        component: () => import("./components/tiles/GenericSateliteWidgetTile.vue")
    },
    "LOT_SAVI_INDEX": {
        meta: {
            i18nDescrKey: "lot_savi_index",
            filters: ['s-c-leader-select-nav-bar-item', 'farm-select-nav-bar-item', 'campaign-select-nav-bar-item', "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "SATELLITE_INDEXES"
        },
        component: () => import("./components/tiles/GenericSateliteWidgetTile.vue")
    }
};

export default globals;
